<template>
  <b-card-code title="Form Edit User">
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required|alpha-dash"
              >
                <label for="">Name</label>
                <b-form-input
                  v-model="model.name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="First Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <label for="">Email</label>
                <b-form-input
                  v-model="model.email"
                  :state="errors.length > 0 ? false : null"
                  type="email"
                  placeholder="Email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Handphone"
                rules="required|alpha-dash"
              >
                <label for="">Handphone</label>
                <b-input-group prepend="+62">
                  <b-form-input
                    type="number"
                    v-model="model.telp"
                    :state="errors.length > 0 ? false : null"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Username"
                rules="required|alpha-dash"
              >
                <label for="">Username</label>
                <b-form-input
                  v-model="model.username"
                  :state="errors.length > 0 ? false : null"
                  placeholder="First Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required|password"
              >
                <label>Password *</label>
                <b-input-group>
                  <b-form-input
                    v-model="model.password"
                    :type="passwordType"
                    :state="errors.length > 0 ? false : null"
                  />
                  <b-input-group-append>
                    <b-button
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="flat-dark"
                      @click="changeTypePassword"
                    >
                      <b-icon icon="eye-slash-fill" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Retype Password"
                rules="required|confirmed:Password"
              >
                <label>Ulangi Password *</label>
                <b-input-group>
                  <b-form-input
                    v-model="model.passValue"
                    :type="rePasswordType"
                    :state="errors.length > 0 ? false : null"
                  />
                  <b-input-group-append>
                    <b-button
                      v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                      variant="flat-dark"
                      @click="changeReTypePassword"
                    >
                      <b-icon icon="eye-slash-fill" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationForm"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code';

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email, confirmed, alphaDash } from '@validations';
import Ripple from 'vue-ripple-directive';

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      model: {},
      passwordType: 'password',
      rePasswordType: 'password',
      required,
      email,
      confirmed,
      alphaDash,
    };
  },
  directives: {
    Ripple,
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line
          this.confirmText();
        }
      });
    },
    changeTypePassword() {
      if (this.passwordType == 'password') {
        this.passwordType = 'text';
      } else if (this.passwordType == 'text') {
        this.passwordType = 'password';
      }
    },

    changeReTypePassword() {
      if (this.rePasswordType == 'password') {
        this.rePasswordType = 'text';
      } else if (this.rePasswordType == 'text') {
        this.rePasswordType = 'password';
      }
    },
    confirmText() {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$swal({
            icon: 'success',
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          });
        }
      });
    },
  },
};
</script>
